export class EventEmitter<Events> {
  #listeners = {} as { [event in keyof Events]: Set<(arg: Events[event]) => void> };

  emit<T extends keyof Events>(eventName: T, arg: Events[T]) {
    this.#listeners[eventName]?.forEach((listener) => listener.call(this, arg));
  }

  once<T extends keyof Events>(eventName: T, listener: (arg: Events[T]) => void): () => void {
    const off = this.on(eventName, (arg) => {
      off();
      listener(arg);
    });
    return off;
  }

  on<T extends keyof Events>(eventName: T, listener: (arg: Events[T]) => void): () => void {
    (this.#listeners[eventName] ??= new Set()).add(listener);
    return () => this.off(eventName, listener);
  }

  off<T extends keyof Events>(eventName: T, listener: (arg: Events[T]) => void): void {
    this.#listeners[eventName]?.delete(listener);
  }
}
